import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as myCfg from '../AppConfig';
import * as ARInvoiceMdls from '../models/ArInvoiceModel';
import * as CreditCardStore from '../store/CreditCard';
import { sawinFunc, ResetStore, APIContainer, LogTypes  } from './sawinLib';
// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface ArInvoiceLoad { type: 'ARINVOICE_LOADINVOICES', newState: ARInvoiceMdls.ArInvoiceModelList }
export interface ArUpdateSelected { type: 'ARINVOICE_UPDATEISSELECTED', itemToUpdate: ARInvoiceMdls.ArInvoiceModel }
export interface ARInvoiceLoading { type: 'ARINVOICE_LOADING' }
export interface ARInvoiceReset { type: 'ARINVOICE_RESET' }

export type KnownAction = ARInvoiceLoading | ArInvoiceLoad | ArUpdateSelected | ResetStore | ARInvoiceReset| CreditCardStore.ChargeCreditReset;
 
export const actionCreators = {
    loadInvoices:(paid: boolean):AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const sessionState = appState.sessionState;
        var CustomerNum = sessionState.SelectedAR.id;
        var CompanyCode = sessionState.SelectedAR.companyCode;
        try {
            dispatch({ type: 'ARINVOICE_RESET' });
            dispatch({ type: 'CREDITCARD_RESETINFO' });
            dispatch({ type: 'ARINVOICE_LOADING' });
            sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + `api/Proxy/OpenInvoices?pCompanyCode=${CompanyCode}&pCustomerCode=${CustomerNum}&pShowPaid=${paid}`,
                {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(response => response.json() as Promise<APIContainer>)
                .then(container => {
                    if (container.success) {
                        console.log("DATA:" + container.data);                      
                        const data = container.data;
                        appState.sessionState.TransactionFeeLabel = data.transactionFeeLabel;                           
                        appState.sessionState.CheckSalesAmtMin = data.checkSalesAmtMin;
                        appState.sessionState.TransactionFeeEnabled = data.transactionFeeEnabled;
                        appState.sessionState.SalesAmountLowerCeiling = data.salesAmountLowerCeiling;
                        appState.sessionState.TransactionFeePerc = data.transactionFeePerc;
                        dispatch({ type: 'ARINVOICE_LOADINVOICES', newState: { items: data.invoices, loading: false } });                        
                    } else {
                        sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                    }
                });
        } catch (e) {
            sawinFunc.log({ message: e, logType: LogTypes.Error, clientMessage: '' });
        }

    },
    updateIsSelectedValue: (newItem: ARInvoiceMdls.ArInvoiceModel): AppThunkAction<KnownAction> => (dispatch, getState) => {        
        dispatch({ type: 'ARINVOICE_UPDATEISSELECTED', itemToUpdate: newItem });        
    }
};

export const reducer: Reducer<ARInvoiceMdls.ArInvoiceModelList> = (state: ARInvoiceMdls.ArInvoiceModelList | undefined, incomingAction: Action): ARInvoiceMdls.ArInvoiceModelList => {

    if (state === undefined) {
        return { ...ARInvoiceMdls.initialListState };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'ARINVOICE_LOADING':
            return { ...state, loading: true }
        case 'ARINVOICE_LOADINVOICES':
            console.log("inc");
            console.log(incomingAction);
            const loadOpenInvoices = incomingAction as ArInvoiceLoad;
            //Add Column to control Selected Invoices  
          
            var OpenInvoicesWithAddedColumn;
            if (loadOpenInvoices.newState && loadOpenInvoices.newState.items) {
                OpenInvoicesWithAddedColumn = loadOpenInvoices.newState.items.map((item) => { return { ...item, isSelectedToPay: false } });

                if (OpenInvoicesWithAddedColumn) {
                    return {
                        ...state, ...{ items: OpenInvoicesWithAddedColumn, loading: false }
                    }
                } else {
                    return {
                        ...state, ...{loading: false }
                    }
                }
            }

            return {
                ...state, ...{ loading: false }
            }

        case 'ARINVOICE_UPDATEISSELECTED':
            const updateSelectAction = incomingAction as ArUpdateSelected;
            const newState = state.items.map((item) => {
                return item.invoiceNumber === updateSelectAction.itemToUpdate.invoiceNumber ? updateSelectAction.itemToUpdate : item;
            })
            return { ...state, ...{ items: newState } };
        case 'STORE_RESET':
        case 'ARINVOICE_RESET':
            return { ...ARInvoiceMdls.initialListState };
        default:
            return state;
    }
}; 